import React from "react";
import { Row, Col } from "antd";
import logoiconsmall from "../../../../assets/img/logo-icon-small.png";
import logotextsmall from "../../../../assets/img/logo-text-small.png";
import { SVGParallelogram } from "./SVGParallelogram";

const PerformanceSpecifications = ({ product_specification }) => {
  const divideArrayIntoParts = (arr) => {
    if (!arr || arr.length === 0) return [];

    const totalLength = arr.length;
    let numParts = 2;

    const chunkSize = Math.ceil(totalLength / numParts);
    const parts = [];

    for (let i = 0; i < numParts; i++) {
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, totalLength);
      parts.push(arr.slice(start, end));
    }

    return parts;
  };

  const getRows = (columnIndex) => {
    const dividedParts = divideArrayIntoParts(
      product_specification
    );
    return dividedParts[columnIndex] || [];
  };

  const renderColumn = (columnIndex) => {
    const rows = getRows(columnIndex);
    return (
      <div style={styles.column}>
        {rows?.map((spec, index) => (
          <div
            key={index}
            style={{
              ...styles.specRow,
              backgroundColor: index % 2 === 0 ? "rgba(242, 242, 242, 1)" : "#ffffff",
              // paddingTop: index % 22 === 0 && index !== 0 ? 120 : 0
            }}
          >
            <div style={styles.label}>{spec.parameter}</div>
            <div
              style={{
                ...styles.value,
                ...(spec.isBlue ? styles.blueValue : {}),
              }}
            >
              {spec.specifications}
            </div>
          </div>
        ))
        }
      </div >
    );
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.titleContainer}>
          <SVGParallelogram skewAmount={42} style={styles.title} width={875}>
            PERFORMANCE SPECIFICATIONS
          </SVGParallelogram>
        </div>
        <div style={styles.logoContainer}>
          <img src={logoiconsmall} alt="Logo Icon" />
          <img src={logotextsmall} alt="Logo Text" />
        </div>
      </div>

      <div style={styles.content}>
        <Row gutter={8}>
          {divideArrayIntoParts(product_specification).map((_, index) => {
            const numParts = divideArrayIntoParts(product_specification).length;
            const span = 24 / numParts; // 12 for 2 cols, 8 for 3 cols, 6 for 4 cols
            return (
              <Col key={index} span={span}>
                {renderColumn(index)}
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

const styles = {
  container: {
    margin: "0",
    width: "98%",
    padding: '10px',
    fontFamily: "Manrope, sans-serif",
    fontWeight: 500,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "12px",
    margin: "0",
    position: "relative",
    overflow: "hidden",
  },
  titleContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  title: {
    color: "white",
    fontSize: "46px",
    margin: "0",
    backgroundColor: "#0C3C78",
    padding: "20px",
    position: "relative",
    zIndex: 2,
    fontFamily: 'Lexend, sans-serif',
    fontWeight: 700,
    letterSpacing: '0%'
  },
  titleShape: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "#00bcd4",
    zIndex: 1,
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    paddingRight: "40px",
  },
  logoIcon: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    backgroundColor: "#00bcd4",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "3px solid white",
  },
  logoC: {
    color: "white",
    fontSize: "24px",
    fontWeight: "bold",
  },
  logoText: {
    display: "flex",
    flexDirection: "column",
    lineHeight: "1",
  },
  cenvance: {
    color: "#00bcd4",
    fontSize: "24px",
    fontWeight: "bold",
    letterSpacing: "1px",
  },
  innovations: {
    color: "#00bcd4",
    fontSize: "14px",
    fontWeight: "normal",
  },
  content: {
    padding: "0",
  },
  column: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  specRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px",
    margin: "0",
    border: "1px solid #ddd",
    borderBottom: "1px solid #ddd",
  },
  label: {
    color: "#5A667A",
    fontSize: "15px",
    fontWeight: 500,
    flex: 1,
    textAlign: "center",
    paddingRight: "10px",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    letterSpacing: '0%'
  },
  value: {
    color: "#0C3C78",
    fontSize: "15px",
    flex: 1,
    fontWeight: 600,
    textAlign: "center",
    wordWrap: "break-word",
    overflowWrap: "break-word",
  },
  blueValue: {
    color: "#0C3C78",
  },
};

export default PerformanceSpecifications;